export const paths = {
    contact: "/kontakt",
    home: "",
    locations: "/locations",
    portfolio: "/our-works",
    privacyPolicy: "/privacy-policy",
};